import { ForexCount } from "@/feature/Forex/api/forex.interface";

export const mapForexCount = (response?: ForexCount): ForexCount => ({
	draft: response?.draft || 0,
	template: response?.template || 0,
});